import { api } from './base';

import { MutationArg, Pageable } from 'v2/types';
import { MailingCampaign, MailingCampaignRequest, MailingPreviewRequest, MailingStats } from 'v2/types/MailingModel';
import { SWRKeyPagination, SWRKeyValue } from 'v2/types/swr';

export const mailingService = {
  getCampaigns([_key, page, limit]: SWRKeyPagination): Promise<Pageable<MailingCampaign>> {
    return api
      .get('v1/admin/mailing', { searchParams: { page, limit, sortFields: JSON.stringify({ createdAt: 'desc' }) } })
      .json();
  },

  getCampaign([_key, campaignId]: SWRKeyValue): Promise<MailingCampaign> {
    return api.get(`v1/admin/mailing/${campaignId}`).json();
  },

  createCampaign(_key: string, { arg }: MutationArg<MailingCampaignRequest>): Promise<MailingCampaign> {
    return api.post('v1/admin/mailing', { json: arg }).json();
  },

  startCampaign([_key, campaignId]: SWRKeyValue): Promise<MailingCampaign> {
    return api.post(`v1/admin/mailing/${campaignId}/start`).json();
  },

  cancelCampaign([_key, campaignId]: SWRKeyValue): Promise<MailingCampaign> {
    return api.post(`v1/admin/mailing/${campaignId}/cancel`).json();
  },

  deleteCampaign([_key, campaignId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/mailing/${campaignId}`).json();
  },

  getStats(): Promise<MailingStats> {
    return api.get('v1/admin/mailing/stats').json();
  },

  sendPreview(_key: string, { arg }: MutationArg<MailingPreviewRequest>): Promise<void> {
    return api.post('v1/admin/mailing/preview', { json: arg }).json();
  },
};
